
    import { Vue, Component, Prop, Watch } from "vue-property-decorator";
    import ProjectModal from "@/components/companyProjects/ProjectModalNew.vue";
    import Breadcrumbs from "@/components/breadcrumbs/BreadcrumbsNew.vue";
    import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
    import ProjectDataDownloader from "@/components/file/project/ProjectDataDownloader.vue";
    import UIButton from "@/components/button/ui-button.vue";
    import { Company, User, Project } from "@/generated/graphql";
    import Roles from "@/entities/Roles";
    import RouteNames from "@/entities/RouteNames";
    import PlusIcon from "@/components/icons/PlusIconNew.vue";
    import HoveredIcon from "@/components/icons/HoveredIcon.vue";
    import ActivityFormModal from "@/components/projects/activities/ActivityFormModalNew.vue";
    import ClientEditModal from "@/components/companyProjects/ClientEditModal.vue";
    import SmartMatchConfigModal from "@/components/smartMatch/SmartMatchConfigModal.vue";

    @Component({
        components: {
            HoveredIcon,
            UIButton,
            PlusIcon,
            ProjectModal,
            LoadingOverlay,
            ActivityFormModal,
            ProjectDataDownloader,
            Breadcrumbs,
            ClientEditModal,
            SmartMatchConfigModal,
        },
    })
    export default class AdminContractorsTabContainer extends Vue {
        @Prop({ type: Object, required: true }) readonly company!: Company;
        @Prop({ type: Object, required: true }) readonly currentUser!: User;

        activeTab = "basic";
        currentEditTab = { tab: 0, step: 0 };
        projects: Project[] = [];
        routes = RouteNames;

        dialog: boolean = false;

        onActivityListItemAdded(): void {
            window.location.reload();
            // this.$apollo.queries.projects.refetch();
            // this.$apollo.queries.visits.refetch();
        }
        openActivityModal(): void {
            this.activityModalOpened = true;
        }

        closeActivityModal(): void {
            this.activityModalOpened = false;
        }

        openSmartMatchModal(): void {
            this.smartMatchModalOpened = true;
        }

        closeSmartMatchModal(): void {
            this.smartMatchModalOpened = false;
        }


        handleClose(): void {
            this.dialog = false;
            window.location.reload();
        }
        hanldeCancel(): void {
            this.dialog = false;
        }
        activityModalOpened = false;
        smartMatchModalOpened = false;

        get isResourcesPage(): boolean {
            return this.$route.path.includes("/company_database/");
        }

        get isAdmin(): boolean {
            return this.currentUser.role === Roles.ADMIN;
        }
        get showDownload(): boolean {
            if (this.$route.path.includes("/all-clients")) return true;
        }

        get showNewVisit(): boolean {
            if (!this.$route.path.includes("/all-clients")) return true;
        }
        get topHeading(): string {
            switch (this.$route.name) {
                case "empty_visits_tab":
                    return "Manage Visits";
                case "accepted_visits":
                    return "Manage Assigned Visits";
                case "completed_visits":
                    return "Manage Completed Visits";
                default:
                    return "Manage Clients";
            }
        }

        get isManager(): boolean {
            return this.currentUser.role === Roles.MANAGER;
        }

        toggle(): void {
            this.dialog = true;
        }
    }
